import * as React from "react";

import { appendToClassName } from "lib/helpers";

interface Props {
  left?: React.ReactNode;
  right?: React.ReactNode;
  center?: React.ReactNode;
  className: string;
}

export function Header3(props: Props) {
  const { left, right, center, className } = props;
  return (
    <>
      <div
        id="header3-container"
        className={appendToClassName("horizontal-container", className)}
      >
        <div>{left}</div>
        <div>{center}</div>
        <div>{right}</div>
      </div>
    </>
  );
}
